import React from 'react';
import '../styles/Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <h2>Contactez Taxi Asprotaxi</h2>

      <div className="contact-container">
        {/* Formulaire */}
        <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
          <label>Nom</label>
          <input type="text" placeholder="Votre nom" required />

          <label>Email</label>
          <input type="email" placeholder="Votre email" required />

          <label>Message</label>
          <textarea placeholder="Votre message" rows="5" required />

          <button type="submit">Envoyer</button>
        </form>

        {/* Infos et carte */}
        <div className="contact-infos">
          <h3>Appelez-nous</h3>
          <p>📞 <a href="tel:+33777685938">07 77 68 59 38</a></p>
          <p>📧 <a href="mailto:taxi.asprotaxi@gmail.com">taxi.asprotaxi@gmail.com</a></p>
          <p>💬 <a href="https://wa.me/33777685938" target="_blank" rel="noreferrer">WhatsApp direct</a></p>

          <h3>Nous localiser</h3>
          <iframe
            title="Carte Taxi Asprotaxi"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2651.0092031217473!2d6.911835615650389!3d47.47659910421507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47923ec70f6149c3%3A0x1649a6e68438820f!2sSainte-Suzanne%2090310!5e0!3m2!1sfr!2sfr!4v1719400000000"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
